<ion-list lines="none">
  <ion-item tappable *ngFor="let opt of groupByOptions" (click)="onSelect(opt.value)">
      {{ opt.label }}
  </ion-item>
</ion-list>
